import { render, staticRenderFns } from "./folders-list-links-payment.vue?vue&type=template&id=629864d7&scoped=true"
import script from "./folders-list-links-payment.vue?vue&type=script&lang=js"
export * from "./folders-list-links-payment.vue?vue&type=script&lang=js"
import style0 from "./folders-list-links-payment.vue?vue&type=style&index=0&id=629864d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629864d7",
  null
  
)

export default component.exports